// src/resources/POSMappings/POSMappingCreate.js
import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  ReferenceInput,
  SelectInput,
} from "react-admin";

export const POSMappingCreate = (props) => (
  <Create {...props} title="Add POS Device Mapping">
    <SimpleForm>
      <TextInput
        source="terminalId"
        label="Terminal ID"
        helperText="As printed in POS report (exact match)."
        fullWidth
      />
      <ReferenceInput
        source="vehicleId"
        reference="vehicles"
        label="Vehicle"
      >
        <SelectInput optionText="vehicleNumber" />
      </ReferenceInput>
      <TextInput
        source="notes"
        label="Notes"
        fullWidth
        multiline
      />
    </SimpleForm>
  </Create>
);
